import { useContext } from 'react';
import classNames from 'classnames';

import { FilesContext } from '@providers/FilesProvider';
import MessageWithBold from '@components/atoms/MessageWithBold';
import { FormattedMessage } from 'utils/intl';

import BadgeIcon from '../BadgeIcon';
import BadgeInfo from '../BadgeInfo';

import messages from './BadgeSection.messages';
import classes from './BadgesSection.module.scss';

const BadgeSectionCocon = () => {
  const { getPageImageConfigs } = useContext(FilesContext);
  const [
    engagePartner,
    veeam,
    intelGold,
    engage1,
    engage2,
    dellPartner,
    apc,
    vmware,
    microsoftPartner,
    eaton,
    lenovoGold,
    lenovoAuthorized,
    lenovoExpert,
  ] = getPageImageConfigs([
    'engage-partner',
    'veeam',
    'intel-gold',
    'FTNT-Engage1',
    'FTNT-Engage2',
    'dell-partner',
    'apc',
    'vmware',
    'microsoft-partner',
    'eaton',
    'lenovo-gold',
    'lenovo-authorized',
    'lenovo-expert',
  ]);

  return (
    <>
      <div className={classNames(classes.section, classes.bigSection)}>
        <BadgeInfo
          className={classes.big}
          iconAlt="engage fortinet advanced partner logo"
          resolveConfig={engagePartner}
          description={
            <MessageWithBold
              message={messages.engage}
              values={{
                bold1: <FormattedMessage {...messages.engageBold1} />,
                bold2: <FormattedMessage {...messages.engageBold2} />,
              }}
            />
          }
        />
        <BadgeInfo
          className={classes.secondBig}
          description={
            <MessageWithBold
              message={messages.veeam}
              values={{
                bold1: <FormattedMessage {...messages.veeamBold1} />,
                bold2: <FormattedMessage {...messages.veeamBold2} />,
                bold3: <FormattedMessage {...messages.veeamBold3} />,
                bold4: <FormattedMessage {...messages.veeamBold4} />,
              }}
            />
          }
          iconAlt="veeam logo"
          resolveConfig={veeam}
        />
      </div>
      <div className={classNames(classes.section, classes.thirdSection)}>
        <BadgeInfo
          className={classes.big}
          iconAlt="intel partner gold logo"
          resolveConfig={intelGold}
          description={
            <MessageWithBold
              message={messages.intel}
              values={{
                bold1: <FormattedMessage {...messages.intelBold1} />,
                bold2: <FormattedMessage {...messages.intelBold2} />,
              }}
            />
          }
        />
        <BadgeIcon className={classes.one} iconAlt="FTNT Engage Specialization Badge logo" resolveConfig={engage1} />
        <BadgeIcon className={classes.two} iconAlt="FTNT Engage Specialization Badge logo" resolveConfig={engage2} />
        <BadgeIcon
          className={classes.three}
          description={<FormattedMessage {...messages.vmware} />}
          iconAlt="vmware logo"
          resolveConfig={vmware}
        />
      </div>
      <div className={classNames(classes.section, classes.bigSection)}>
        <BadgeInfo
          className={classes.big}
          iconAlt="titanium partner dell technologies logo"
          resolveConfig={dellPartner}
          description={
            <MessageWithBold
              message={messages.dell}
              values={{
                bold1: <FormattedMessage {...messages.dellBold1} />,
                bold2: <FormattedMessage {...messages.dellBold2} />,
                bold3: <FormattedMessage {...messages.dellBold3} />,
                bold4: <FormattedMessage {...messages.dellBold4} />,
              }}
            />
          }
        />
        <BadgeInfo
          className={classes.secondBig}
          description={
            <MessageWithBold
              message={messages.statusSelect}
              values={{
                bold1: <FormattedMessage {...messages.statusSelectBold1} />,
                bold2: <FormattedMessage {...messages.statusSelectBold2} />,
                bold3: <FormattedMessage {...messages.statusSelectBold3} />,
              }}
            />
          }
          iconAlt="apc logo"
          resolveConfig={apc}
        />
      </div>
      <div className={classNames(classes.section, classes.bigSection, classes.reverse)}>
        <BadgeInfo
          className={classes.big}
          iconAlt="microsoft partner logo"
          resolveConfig={microsoftPartner}
          description={
            <MessageWithBold
              message={messages.microsoftSilver}
              values={{ bold: <FormattedMessage {...messages.microsoftSilverBold} /> }}
            />
          }
        />
        <BadgeInfo
          className={classes.secondBig}
          description={
            <MessageWithBold
              message={messages.eaton}
              values={{
                bold1: <FormattedMessage {...messages.eatonBold1} />,
                bold2: <FormattedMessage {...messages.eatonBold2} />,
                bold3: <FormattedMessage {...messages.eatonBold3} />,
              }}
            />
          }
          iconAlt="eaton logo"
          resolveConfig={eaton}
        />
      </div>
      <div className={classNames(classes.section, classes.rowSection)}>
        <BadgeIcon className={classes.one} iconAlt="lenovo gold logo" resolveConfig={lenovoGold} />
        <BadgeIcon className={classes.two} iconAlt="lenovo authorized logo" resolveConfig={lenovoAuthorized} />
        <BadgeIcon
          className={classes.three}
          description={
            <MessageWithBold
              message={messages.lenovo}
              values={{
                bold1: <FormattedMessage {...messages.lenovoBold1} />,
                bold2: <FormattedMessage {...messages.lenovoBold2} />,
                bold3: <FormattedMessage {...messages.lenovoBold3} />,
              }}
            />
          }
          iconAlt="lenovo expert logo"
          resolveConfig={lenovoExpert}
        />
      </div>
    </>
  );
};

export default BadgeSectionCocon;
